import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';

// CON-2014 — the read-only Short codes entry in Connections. Texts from 5-6
// digit short codes have no contact; they are read here, never replied to.

export const GET_SHORT_CODES = '@shortCodes/get-short-codes';
export const GET_SHORT_CODES_SUCCESS = '@shortCodes/get-short-codes-success';
export const GET_SHORT_CODES_ERROR = '@shortCodes/get-short-codes-error';

export const GET_SHORT_CODE_THREAD = '@shortCodes/get-short-code-thread';
export const GET_SHORT_CODE_THREAD_SUCCESS = '@shortCodes/get-short-code-thread-success';
export const GET_SHORT_CODE_THREAD_ERROR = '@shortCodes/get-short-code-thread-error';

export const MARK_SHORT_CODE_READ_SUCCESS = '@shortCodes/mark-short-code-read-success';

export const SOCKET_SHORT_CODE_MESSAGE = '@shortCodes/socket-short-code-message';

const errorText = (e) => {
  const { error, message } = e?.response?.data || {};
  return helpers.transform.toString(message || error || 'Server error');
};

export const getShortCodes = () => async (dispatch) => {
  dispatch({ type: GET_SHORT_CODES });
  try {
    const response = await axios.get('/api/messages/short-codes');
    dispatch({ type: GET_SHORT_CODES_SUCCESS, payload: response?.data || {} });
  } catch (e) {
    dispatch({ type: GET_SHORT_CODES_ERROR });
  }
};

// cursor null loads the newest page; a cursor loads the page before it.
export const getShortCodeThread = (code, cursor = null) => async (dispatch) => {
  dispatch({ type: GET_SHORT_CODE_THREAD, payload: { code } });
  try {
    const response = await axios.get(`/api/messages/short-codes/${code}`, {
      params: { cursor: cursor || undefined },
    });
    dispatch({
      type: GET_SHORT_CODE_THREAD_SUCCESS,
      payload: { code, isOlderPage: !!cursor, data: response?.data || {} },
    });
  } catch (e) {
    dispatch(addNotification(GET_SHORT_CODE_THREAD_ERROR, errorText(e), NOTIFICATION_STATUS.ERROR));
    dispatch({ type: GET_SHORT_CODE_THREAD_ERROR, payload: { code } });
  }
};

// Same endpoint as a contact chat: PATCH /api/messages/read by message ids.
// The server then sends the new unread total over the socket.
export const markShortCodeRead = (code, messageIds) => async (dispatch) => {
  if (helpers.isEmpty(messageIds)) return;
  try {
    await axios.patch('/api/messages/read', { id: messageIds });
    dispatch({ type: MARK_SHORT_CODE_READ_SUCCESS, payload: { code, messageIds } });
  } catch (e) {
    dispatch(addNotification(GET_SHORT_CODE_THREAD_ERROR, errorText(e), NOTIFICATION_STATUS.ERROR));
  }
};

// Socket payload: { shortCode, message }
export const socketShortCodeMessage = (payload) => ({
  type: SOCKET_SHORT_CODE_MESSAGE,
  payload,
});
